import { getLoginRequest } from '../api/request';


export const getLogin = ({payload, callback}) => {
  return (dispatch) => {
    getLoginRequest(payload).then(res => {
      callback && callback(res)
      if(res.code === 'SUCCESS') {
        //dispatch(getLoginStatus(res))
      }
    }).catch(err => {
      callback && callback(err)
    })
  }
}
